import $ from 'jquery';

$(function () {
  let headerHeight = parseFloat($('body').css('--header-height'));
  let filterBarHeight = parseFloat($('body').css('--filter-bar-height'));

  $('a[href^="#"]').on('click', function (e) {
    const target = $(this.getAttribute('href'));
    console.log(target);
    if (target.length) {
      e.preventDefault();
      $('html, body').animate(
        {
          scrollTop: target.offset().top - (headerHeight + filterBarHeight + 30),
        },
        500
      );
    }
  });

  $(window).on('resize', function () {
    let newHeaderHeight = parseFloat($('body').css('--header-height'));
    let newFilterBarHeight = parseFloat($('body').css('--filter-bar-height'));

    headerHeight = newHeaderHeight;
    filterBarHeight = newFilterBarHeight;
  });
});
